import { colors } from 'component-library/styles/colors';
import styled from 'styled-components';

interface GridSectionWrapperProps {
  padding: string;
}

export const GridSectionWrapper = styled.div<GridSectionWrapperProps>`
  background: ${colors.white};
  border: 1px solid ${colors.black};
  border-radius: 24px;
  padding: ${({ padding }) => padding};
`;
